export default "__VITE_ASSET__DckWFHb6__"